import { render, staticRenderFns } from "./Consumibles.vue?vue&type=template&id=2fce2171&scoped=true&"
import script from "./Consumibles.vue?vue&type=script&lang=js&"
export * from "./Consumibles.vue?vue&type=script&lang=js&"
import style0 from "./Consumibles.vue?vue&type=style&index=0&id=2fce2171&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fce2171",
  null
  
)

export default component.exports